import React from "react";
import { Box, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";

const formatBRL = (v) => {
  if (v === null || v === undefined) return "-";
  if (typeof v !== "number") return String(v);
  return v.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

// Cabeçalho de colunas conforme a planilha da imagem
const COLS = [
  { key: "inssAdm", label: "INSS\nAdministrativo" },
  { key: "inssJud", label: "INSS\nJudicial" },
  { key: "pisAdm", label: "PIS Administrativo" },
  { key: "pisJud", label: "PIS\nJudicial" },
  { key: "cofinsAdm", label: "COFINS\nAdministrativo" },
  { key: "cofinsJud", label: "COFINS\nJudicial" },
  { key: "irpjAdm", label: "IRPJ \nAdministravo" },
  { key: "irpjJud", label: "IRPJ\nJudicial" },
  { key: "csllAdm", label: "CSLL \nAdministrativo" },
  { key: "csllJud", label: "CSLL\nJudicial" },
  { key: "icmsAdm", label: "ICMS\nAdministrativo" },
  { key: "icmsJud", label: "ICMS\nJudicial" },
  { key: "icmsStAdm", label: "ICMS-ST\nAdministrativo" },
  { key: "icmsStJud", label: "ICMS-ST\nJudicial" },
  { key: "issAdm", label: "ISS\nAdministrativo" },
  { key: "issJud", label: "ISS\nJudicial" },
  { key: "acaoJud", label: "Ação\nJudicial" },
  { key: "totalAdm", label: "Total\nAdministrativo" },
  { key: "totalJud", label: "Total \nJudicial" },
  { key: "totalGeral", label: "Total\nGeral" },
];

// Dados mocados baseados na imagem enviada
const MOCK = {
  empresa: {
    razaoSocial: "RAZÃO SOCIAL",
    cnpj: "CNPJ",
    regimePorAno: {
      2020: "PRESUMIDO",
      2021: "REAL",
      2022: "REAL",
      2023: "REAL",
      2024: "REAL",
      2025: "REAL",
    },
  },
  bloco1: [
    {
      label: "CRÉDITOS LEVANTADOS",
      values: {
        inssAdm: 90618.06,
        inssJud: null,
        pisAdm: 1000752.0,
        pisJud: 33.92,
        cofinsAdm: 2001300.0,
        cofinsJud: 100.0,
        irpjAdm: 75000.0,
        irpjJud: null,
        csllAdm: 22000.0,
        csllJud: null,
        icmsAdm: 25000.0,
        icmsJud: null,
        icmsStAdm: null,
        icmsStJud: null,
        issAdm: 25000.0,
        issJud: null,
        acaoJud: 9562681.28,
        totalAdm: 3239670.06,
        totalJud: 9562815.2,
        totalGeral: 12802485.26,
      },
    },
    {
      label: "CRÉDITOS UTILIZADOS NO SPED",
      values: {
        inssAdm: null,
        inssJud: null,
        pisAdm: 3300.0,
        pisJud: null,
        cofinsAdm: 15200.0,
        cofinsJud: null,
        irpjAdm: null,
        irpjJud: null,
        csllAdm: null,
        csllJud: null,
        icmsAdm: 36000.0,
        icmsJud: null,
        icmsStAdm: null,
        icmsStJud: null,
        issAdm: null,
        issJud: null,
        acaoJud: null,
        totalAdm: 54500.0,
        totalJud: null,
        totalGeral: 54500.0,
      },
    },
    {
      label: "CRÉDITOS UTILIZADOS EM DCOMP",
      values: {
        inssAdm: null,
        inssJud: null,
        pisAdm: null,
        pisJud: null,
        cofinsAdm: null,
        cofinsJud: null,
        irpjAdm: null,
        irpjJud: null,
        csllAdm: null,
        csllJud: null,
        icmsAdm: null,
        icmsJud: null,
        icmsStAdm: null,
        icmsStJud: null,
        issAdm: null,
        issJud: null,
        acaoJud: null,
        totalAdm: null,
        totalJud: null,
        totalGeral: null,
      },
    },
    {
      label: "CRÉDITOS UTILIZADOS",
      values: {
        inssAdm: null,
        inssJud: null,
        pisAdm: 3300.0,
        pisJud: null,
        cofinsAdm: 15200.0,
        cofinsJud: null,
        irpjAdm: null,
        irpjJud: null,
        csllAdm: null,
        csllJud: null,
        icmsAdm: 36000.0,
        icmsJud: null,
        icmsStAdm: null,
        icmsStJud: null,
        issAdm: null,
        issJud: null,
        acaoJud: null,
        totalAdm: 54500.0,
        totalJud: null,
        totalGeral: 54500.0,
      },
    },
    {
      label: "CRÉDITO DISPONÍVEL",
      values: {
        inssAdm: 90618.06,
        inssJud: null,
        pisAdm: 997452.0,
        pisJud: 33.92,
        cofinsAdm: 1986100.0,
        cofinsJud: 100.0,
        irpjAdm: 75000.0,
        irpjJud: null,
        csllAdm: 22000.0,
        csllJud: null,
        icmsAdm: -11000.0,
        icmsJud: null,
        icmsStAdm: null,
        icmsStJud: null,
        issAdm: 25000.0,
        issJud: null,
        acaoJud: 9562681.28,
        totalAdm: 3185170.06,
        totalJud: 9562815.2,
        totalGeral: 12747985.26,
      },
    },
  ],
  bloco2: [
    {
      label: "CRÉDITO CONSTITUÍDO",
      values: {
        inssAdm: 300000.0,
        inssJud: null,
        pisAdm: 2000000.0,
        pisJud: null,
        cofinsAdm: null,
        cofinsJud: null,
        irpjAdm: null,
        irpjJud: null,
        csllAdm: null,
        csllJud: null,
        icmsAdm: null,
        icmsJud: null,
        icmsStAdm: null,
        icmsStJud: null,
        issAdm: null,
        issJud: null,
        acaoJud: 2000000.0,
        totalAdm: null,
        totalJud: null,
        totalGeral: null,
      },
    },
    {
      label: "COMPENSAÇÃO NO SPED",
      values: {
        inssAdm: null,
        inssJud: null,
        pisAdm: 3300.0,
        pisJud: null,
        cofinsAdm: 15200.0,
        cofinsJud: null,
        irpjAdm: null,
        irpjJud: null,
        csllAdm: null,
        csllJud: null,
        icmsAdm: 36000.0,
        icmsJud: null,
        icmsStAdm: null,
        icmsStJud: null,
        issAdm: null,
        issJud: null,
        acaoJud: null,
        totalAdm: null,
        totalJud: null,
        totalGeral: null,
      },
    },
    {
      label: "CRÉDITOS A CONSTITUIR",
      values: {
        inssAdm: -209381.94,
        inssJud: null,
        pisAdm: -1002548.0,
        pisJud: 33.92,
        cofinsAdm: 1986100.0,
        cofinsJud: 100.0,
        irpjAdm: 75000.0,
        irpjJud: null,
        csllAdm: 22000.0,
        csllJud: null,
        icmsAdm: -11000.0,
        icmsJud: null,
        icmsStAdm: null,
        icmsStJud: null,
        issAdm: 25000.0,
        issJud: null,
        acaoJud: 7562681.28,
        totalAdm: null,
        totalJud: null,
        totalGeral: null,
      },
    },
    {
      label: "SALDO DISPONÍVEL EM DCOMP",
      values: {
        inssAdm: null,
        inssJud: null,
        pisAdm: null,
        pisJud: null,
        cofinsAdm: null,
        cofinsJud: null,
        irpjAdm: null,
        irpjJud: null,
        csllAdm: null,
        csllJud: null,
        icmsAdm: null,
        icmsJud: null,
        icmsStAdm: null,
        icmsStJud: null,
        issAdm: null,
        issJud: null,
        acaoJud: null,
        totalAdm: null,
        totalJud: null,
        totalGeral: null,
      },
    },
  ],
  ce: {
    label: "C. E.",
    values: {
      inssAdm: 500.0,
      pisAdm: 1000.0,
    },
  },
};

const HeaderEmpresa = ({ empresa }) => {
  const anos = Object.keys(empresa.regimePorAno || {});
  return (
    <Paper
      elevation={0}
      sx={{
        mb: 2,
        display: "inline-block",
        border: "2px solid #0b2d6b",
        background: "#fff",
        width: { xs: "100%", md: "auto" },
        minWidth: { md: 900 },
      }}
    >
      <Table size="small" sx={{ borderCollapse: "collapse", width: "100%" }}>
        <TableBody>
          {/* Faixas azuis como no print, ocupando toda a largura */}
          <TableRow>
            <TableCell colSpan={2} sx={{ background: "#002d72", color: "#fff", fontWeight: 900, textTransform: "uppercase", px: 1, py: 0.4, fontSize: 12, borderBottom: "1px solid #ffffff" }}>
              Razão Social
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={2} sx={{ background: "#002d72", color: "#fff", fontWeight: 900, textTransform: "uppercase", px: 1, py: 0.4, fontSize: 12, borderBottom: "2px solid #0b2d6b" }}>
              CNPJ
            </TableCell>
          </TableRow>

          {/* Linha com REGIME TRIBUTÁRIO à esquerda e grade anos/regimes à direita */}
          <TableRow>
            <TableCell sx={{ textTransform: "uppercase", fontWeight: 900, px: 1.2, py: 1.2, fontSize: 12, width: 280, borderRight: cellBorder, textAlign: "center", verticalAlign: "middle" }}>
              Regime Tributário
            </TableCell>
            <TableCell sx={{ p: 0 }}>
              <Table size="small" sx={{ borderCollapse: "collapse", width: "100%" }}>
                <TableHead>
                  <TableRow>
                    {anos.map((ano, idx) => (
                      <TableCell
                        key={ano}
                        sx={{
                          textAlign: "center",
                          fontWeight: 800,
                          textTransform: "uppercase",
                          px: 1.1,
                          py: 0.55,
                          fontSize: 12,
                          borderTop: "1.5px solid #0b2d6b",
                          borderBottom: "1.5px solid #0b2d6b",
                          borderLeft: idx === 0 ? cellBorder : cellBorder,
                          borderRight: idx === anos.length - 1 ? "1.5px solid #0b2d6b" : cellBorder,
                          background: "#fff",
                        }}
                      >
                        {ano}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    {anos.map((ano, idx) => (
                      <TableCell
                        key={ano}
                        sx={{
                          textAlign: "center",
                          fontWeight: 900,
                          textTransform: "uppercase",
                          color: "#c63b10",
                          px: 1.1,
                          py: 0.6,
                          borderBottom: "1.5px solid #0b2d6b",
                          borderLeft: idx === 0 ? cellBorder : cellBorder,
                          borderRight: idx === anos.length - 1 ? "1.5px solid #0b2d6b" : cellBorder,
                          background: "#fff",
                        }}
                      >
                        {String(empresa.regimePorAno[ano] || "").toUpperCase()}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableBody>
              </Table>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Paper>
  );
};

const cellBorder = "1px solid #e3e8f0";

// Estilos por coluna para se aproximar da paleta da planilha
const judicialKeys = new Set(["inssJud","pisJud","cofinsJud","irpjJud","csllJud","icmsJud","icmsStJud","issJud","acaoJud","totalJud"]);
const totalGeralKey = "totalGeral";
const totalAdmKey = "totalAdm";
const totalJudKey = "totalJud";
const TOTAL_COL_WIDTH = 140;
const RAIL_WIDTH = TOTAL_COL_WIDTH * 3;

const isTotalKey = (key) => key === totalGeralKey || key === totalAdmKey || key === totalJudKey;
const getRightOffset = (key) => {
  // Order: totalGeral (0), totalJud (1), totalAdm (2) so they stack from right to left
  if (key === totalGeralKey) return 0;
  if (key === totalJudKey) return TOTAL_COL_WIDTH;
  if (key === totalAdmKey) return TOTAL_COL_WIDTH * 2;
  return undefined;
};

const getColStyle = (key, isHeader = false) => {
  // Totais gerais: fundo azul escuro e texto branco
  if (key === totalGeralKey) {
    return isHeader
      ? { background: "#0b2d6b", color: "#fff", fontWeight: 800 }
      : { background: "#0b2d6b", color: "#fff", fontWeight: 700 };
  }
  // Totais administrativo/judicial: azul médio
  if (key === totalAdmKey) {
    return isHeader ? { background: "#d6e6ff" } : { background: "#eef4ff" };
  }
  if (key === totalJudKey) {
    return isHeader ? { background: "#bcd0ff" } : { background: "#e3ecff" };
  }
  // Colunas judiciais: azul mais visível
  if (judicialKeys.has(key)) {
    const bg = isHeader ? "#cfe0ff" : "#eaf1ff";
    return { background: bg };
  }
  // Demais (administrativas): leve azul no cabeçalho, corpo neutro
  if (isHeader) return { background: "#eaf1ff" };
  return {};
};

const TabelaBloco = ({ titulo, linhas, stickyTotalsRight = false }) => {
  const leftScrollRef = React.useRef(null);
  const rightScrollRef = React.useRef(null);
  const headerBarRef = React.useRef(null);
  const leftHeaderRowRef = React.useRef(null);
  const firstDataRowRef = React.useRef(null);
  const totalsOverlayRef = React.useRef(null);
  const firstRightCellRef = React.useRef(null);
  const [showTopShadow, setShowTopShadow] = React.useState(false);
  const [showBottomShadow, setShowBottomShadow] = React.useState(false);
  const [headerHeight, setHeaderHeight] = React.useState(0);
  const [leftHeaderRowHeight, setLeftHeaderRowHeight] = React.useState(0);
  const [firstRowHeight, setFirstRowHeight] = React.useState(0);
  const [alignDelta, setAlignDelta] = React.useState(0);
  const leftCols = React.useMemo(() => COLS.filter((c) => !isTotalKey(c.key)), []);
  const rightCols = React.useMemo(() => [
    COLS.find(c => c.key === totalAdmKey),
    COLS.find(c => c.key === totalJudKey),
    COLS.find(c => c.key === totalGeralKey),
  ].filter(Boolean), []);

  const updateShadows = () => {
    const el = leftScrollRef.current;
    if (!el) return;
    const { scrollTop, scrollHeight, clientHeight } = el;
    setShowTopShadow(scrollTop > 0);
    setShowBottomShadow(scrollTop + clientHeight < scrollHeight - 1);
    if (rightScrollRef.current) rightScrollRef.current.scrollTop = scrollTop;
  };

  const syncFromRight = () => {
    const el = rightScrollRef.current;
    if (!el) return;
    const { scrollTop } = el;
    if (leftScrollRef.current && leftScrollRef.current.scrollTop !== scrollTop) {
      leftScrollRef.current.scrollTop = scrollTop;
    }
  };

  React.useEffect(() => {
    updateShadows();
  }, [linhas]);

  React.useEffect(() => {
    const calc = () => {
      if (headerBarRef.current) setHeaderHeight(headerBarRef.current.offsetHeight);
      if (leftHeaderRowRef.current) setLeftHeaderRowHeight(leftHeaderRowRef.current.offsetHeight);
      if (firstDataRowRef.current) setFirstRowHeight(firstDataRowRef.current.offsetHeight);
      // mede o gap visual entre o overlay dos headers e a 1ª célula dos totalizadores
      requestAnimationFrame(() => {
        const overlayBottom = totalsOverlayRef.current?.getBoundingClientRect?.().bottom || 0;
        const firstCellTop = firstRightCellRef.current?.getBoundingClientRect?.().top || 0;
        const delta = firstCellTop && overlayBottom ? Math.max(0, Math.round(firstCellTop - overlayBottom)) : 0;
        setAlignDelta(delta);
      });
    };
    calc();
    window.addEventListener('resize', calc);
    return () => window.removeEventListener('resize', calc);
  }, []);

  return (
    <Paper elevation={0} sx={{ overflow: "hidden", mb: 3, position: "relative", background: "#fff" }}>
      <Box ref={headerBarRef} sx={{ background: "#002d72", color: "#fff", px: 1.25, py: 0.55 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>{titulo}</Typography>
      </Box>
      {/* Right rail background to make totals look outside the content grid */}
      {stickyTotalsRight && (
        <Box sx={{ position: "absolute", top: `${headerHeight}px`, right: 0, bottom: 0, width: `${RAIL_WIDTH}px`, background: "#fff", zIndex: 0, pointerEvents: "none" }} />
      )}
      {/* Overlay dos headers dos totalizadores (não aumenta a altura do header principal) */}
      {stickyTotalsRight && (
        <Box
          ref={totalsOverlayRef}
          sx={{
            position: 'absolute',
            top: `${headerHeight}px`,
            right: 0,
            width: `${RAIL_WIDTH}px`,
            height: `${leftHeaderRowHeight}px`,
            display: 'flex',
            zIndex: 3,
            transform: 'translateX(-1px)', // sobrepõe 1px para eliminar a linha fina
          }}
        >
          {rightCols.map((c) => (
            <Box
              key={c.key}
              sx={{
                width: TOTAL_COL_WIDTH,
                minWidth: TOTAL_COL_WIDTH,
                maxWidth: TOTAL_COL_WIDTH,
                px: 0.5,
                py: 0.35,
                fontSize: 10.5,
                fontWeight: 700,
                lineHeight: 1.02,
                whiteSpace: 'pre-line',
                textAlign: 'right',
                borderBottom: cellBorder,
                color: c.key === totalGeralKey ? '#fff' : '#102a43',
                ...getColStyle(c.key, true),
              }}
            >
              {c.label}
            </Box>
          ))}
        </Box>
      )}
      <Box sx={{ position: "relative" }}>
        {/* LEFT: content scrollable table without totals */}
        <Box
          ref={leftScrollRef}
          onScroll={updateShadows}
          sx={{ maxHeight: 520, overflow: "auto", position: "relative", pr: stickyTotalsRight ? `${RAIL_WIDTH}px` : 0 }}
        >
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  ref={leftHeaderRowRef}
                  sx={{
                    fontWeight: 700,
                    position: "sticky",
                    left: 0,
                    top: 0,
                    background: "#fff",
                    zIndex: 10, // garante que nada sobreponha o header Descrição
                    boxShadow: '3px 0 4px -2px rgba(0,0,0,0.15)',
                    px: 0.5,
                    py: 0.35,
                    borderRight: cellBorder,
                    borderBottom: cellBorder,
                    fontSize: 10.5,
                    minWidth: 180,
                  }}
                >
                  Descrição
                </TableCell>
                {leftCols.map((c) => (
                  <TableCell
                    key={c.key}
                    sx={{
                      whiteSpace: "pre-line",
                      textAlign: "right",
                      fontWeight: 700,
                      color: "#102a43",
                      px: 0.5,
                      py: 0.35,
                      lineHeight: 1.02,
                      fontSize: 10.5,
                      borderBottom: cellBorder,
                      verticalAlign: 'top',
                      ...getColStyle(c.key, true),
                    }}
                  >
                    {c.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {linhas.map((row, idx) => (
                <TableRow key={row.label} ref={idx === 0 ? firstDataRowRef : null}>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      position: "sticky",
                      left: 0,
                      background: "#fff",
                      zIndex: 9, // abaixo apenas do header, acima das demais colunas
                      boxShadow: '3px 0 4px -2px rgba(0,0,0,0.12)',
                      px: 0.65,
                      py: 0.5,
                      fontSize: 11,
                      borderRight: cellBorder,
                      minWidth: 180,
                    }}
                  >
                    {row.label}
                  </TableCell>
                  {leftCols.map((c) => (
                    <TableCell
                      key={c.key}
                      align="right"
                      sx={{
                        color: (row.values[c.key] ?? 0) < 0 ? "#c62828" : "inherit",
                        px: 0.5,
                        py: 0.5,
                        fontSize: 11,
                        borderBottom: cellBorder,
                        ...getColStyle(c.key, false),
                      }}
                    >
                      {formatBRL(row.values[c.key])}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>

        {/* RIGHT: totals in a separate fixed rail, synced vertically */}
        {stickyTotalsRight && (
          <Box
            ref={rightScrollRef}
            sx={{
              position: "absolute",
              top: `${headerHeight}px`,
              right: 0,
              bottom: 0,
              width: `${RAIL_WIDTH}px`,
              overflowY: 'auto', // precisa rolar para alinhar com a tabela esquerda
              overflowX: 'hidden',
              // esconder scrollbar visual mantendo a rolagem programática
              '&::-webkit-scrollbar': { width: 0, height: 0 },
              scrollbarWidth: 'none',
              pt: `${leftHeaderRowHeight}px`, // base: altura do header
              mt: `-${alignDelta}px`, // aproxima para ficar colado sob o header dos totalizadores
              transform: 'translateX(-1px)', // sobrepõe 1px para eliminar a linha fina
            }}
            onScroll={syncFromRight}
          >
            <Table size="small" stickyHeader sx={{ tableLayout: "fixed", width: `${RAIL_WIDTH}px` }}>
              <TableBody>
                {linhas.map((row, rIdx) => (
                  <TableRow key={row.label}>
                    {rightCols.map((c) => (
                      <TableCell
                        key={c.key}
                        align="right"
                        sx={{
                          color: c.key === totalGeralKey ? "#fff" : (row.values[c.key] ?? 0) < 0 ? "#c62828" : "inherit",
                          px: 0.5,
                          py: 0.5,
                          fontSize: 11,
                          borderBottom: cellBorder,
                          minWidth: TOTAL_COL_WIDTH,
                          maxWidth: TOTAL_COL_WIDTH,
                          ...getColStyle(c.key, false),
                          fontWeight: c.key === totalGeralKey ? 700 : undefined,
                        }}
                        ref={rIdx === 0 && c.key === rightCols[0].key ? firstRightCellRef : null}
                      >
                        {formatBRL(row.values[c.key])}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        )}
      </Box>
      {/* Scroll affordances */}
      {showTopShadow && (
        <Box sx={{ position: "absolute", top: `${headerHeight}px`, left: 0, right: stickyTotalsRight ? `${RAIL_WIDTH}px` : 0, height: 14, background: "linear-gradient(180deg, rgba(0,0,0,0.08), rgba(0,0,0,0))", pointerEvents: "none" }} />
      )}
      {showBottomShadow && (
        <>
          <Box sx={{ position: "absolute", bottom: 0, left: 0, right: stickyTotalsRight ? `${RAIL_WIDTH}px` : 0, height: 16, background: "linear-gradient(0deg, rgba(0,0,0,0.1), rgba(0,0,0,0))", pointerEvents: "none" }} />
          <Box sx={{ position: "absolute", bottom: 8, right: stickyTotalsRight ? `${RAIL_WIDTH - 130}px` : 10, background: "#002d72", color: "#fff", px: 1, py: 0.25, borderRadius: 1, fontSize: 11, opacity: 0.9 }}>
            Role para ver mais ⤓
          </Box>
        </>
      )}
    </Paper>
  );
};

const LinhaCE = ({ ce }) => {
  return (
    <Box sx={{ width: "100%" }}>
      <Paper elevation={0} sx={{ overflowX: "auto", mb: 2, background: "#fff" }}>
        <Table size="small">
          <TableBody>
            <TableRow>
              <TableCell sx={{ fontWeight: 800, textTransform: "uppercase", color: "#c63b10", px: 0.8, py: 0.6, fontSize: 12, borderRight: cellBorder, background: "#fff" }}>
                {ce.label}
              </TableCell>
              {COLS.map((c) => (
                <TableCell key={c.key} align="right" sx={{ px: 0.8, py: 0.6, fontSize: 12, borderBottom: cellBorder, background: "#fff" }}>
                  {formatBRL(ce.values[c.key])}
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
};

const ResumoCreditosPlanilha = ({ data = MOCK, embedded = false }) => {
  return (
    <Box sx={embedded ? { pb: 2 } : { maxWidth: 1500, mx: "auto", px: { xs: 1.5, md: 3 }, pb: 4 }}>
      {/* Top-left small header block */}
      <HeaderEmpresa empresa={data.empresa} />

      {/* Full-width big tables within content area and with internal scroll */}
    <TabelaBloco titulo="CRÉDITOS - RESUMO" linhas={data.bloco1} stickyTotalsRight />
    <TabelaBloco titulo="CONSTITUIÇÃO / COMPENSAÇÃO" linhas={data.bloco2} />

      {/* Small C.E. row as a smaller table aligned left */}
      <LinhaCE ce={data.ce} />
    </Box>
  );
};

export default ResumoCreditosPlanilha;
